const onAccountBalancesOverviewPageMatch = () => {
  console.log('Lux Inject: Running onAccountBalancesOverviewPageMatch')

  const anchorSelector = '.header-buttons'
  const buttonId = 'lux-audit-complete-button'

  // Helper to get URL parameters
  const getUrlParams = () => {
    const path = window.location.pathname
    const searchParams = new URLSearchParams(window.location.search)
    const propertyMatch = path.match(
      /^\/dashboard\/account-sheet\/property\/([^/]+)/
    )
    const property_hr_id = propertyMatch ? propertyMatch[1] : null
    const startDate = searchParams.get('startDate')
    const endDate = searchParams.get('endDate')
    return { property_hr_id, startDate, endDate }
  }

  const initializeButton = async () => {
    const anchorElement = document.querySelector(anchorSelector)
    if (!anchorElement) {
      console.log('Lux Inject: Anchor for audit button not found. Retrying...')
      return false
    }

    if (document.getElementById(buttonId)) {
      console.log('Lux Inject: Audit button already initialized.')
      return true
    }

    console.log('Lux Inject: Initializing audit button...')
    const auditButton = document.createElement('button')
    auditButton.type = 'button'
    auditButton.classList = 'ant-btn ant-btn-text Button'

    auditButton.id = buttonId
    auditButton.textContent = 'Belegprüfung lädt...' // Initial loading text
    auditButton.disabled = true // Initially disabled

    // Insert the button into the DOM synchronously BEFORE async operations
    anchorElement.insertBefore(auditButton, anchorElement.childNodes[0])
    console.log(
      'Lux Inject: Audit button element injected, now fetching status...'
    )

    // Ensure utility functions are available
    const currentShowToast =
      typeof showToast === 'function'
        ? showToast
        : window.showToast || (() => console.warn('showToast not found'))
    const currentApiClientGet =
      typeof Lux_ApiClient_get === 'function'
        ? Lux_ApiClient_get
        : window.Lux_ApiClient_get ||
          (() => {
            console.error('Lux_ApiClient_get not found')
            return Promise.reject(new Error('Lux_ApiClient_get not found'))
          })
    const currentApiClientPost =
      typeof Lux_ApiClient_post === 'function'
        ? Lux_ApiClient_post
        : window.Lux_ApiClient_post ||
          (() => {
            console.error('Lux_ApiClient_post not found')
            return Promise.reject(new Error('Lux_ApiClient_post not found'))
          })

    const { property_hr_id, startDate, endDate } = getUrlParams()

    if (!property_hr_id || !startDate || !endDate) {
      console.warn(
        'Lux Inject: Missing property_hr_id, startDate, or endDate from page URL. Button will be disabled.'
      )
      auditButton.disabled = true // Remains disabled
      auditButton.title =
        'Auditzeitraum nicht vollständig in der URL definiert.'
      // Optionally show a toast, but might be too noisy on every page load if params are often missing
      // currentShowToast('Auditzeitraum nicht vollständig definiert. Button deaktiviert.', 'warning');
      // No need to change textContent here as it's already 'Belegprüfung lädt...' and will stay disabled.
    } else {
      // Fetch initial audit status
      try {
        const response = await currentApiClientGet(
          `/api/properties/${property_hr_id}?startDate=${startDate}&endDate=${endDate}`
        )
        if (response.ok) {
          const data = await response.json()
          if (data.auditCompleted) {
            auditButton.textContent = 'Belegprüfung abgeschlossen'
            auditButton.disabled = true // Stays disabled
            console.log('Lux Inject: Audit already completed for this period.')
          } else {
            auditButton.textContent = 'Belegprüfung abschliessen'
            auditButton.disabled = false // Enable for action
          }
        } else {
          console.error(
            'Lux Inject: Error fetching initial audit status.',
            await response.text()
          )
          auditButton.textContent = 'Statusprüfung fehlgeschlagen' // Error state text
          auditButton.disabled = true // Keep disabled on error
        }
      } catch (error) {
        console.error(
          'Lux Inject: Exception fetching initial audit status.',
          error
        )
        auditButton.textContent = 'Statusprüfung fehlgeschlagen' // Error state text
        auditButton.disabled = true // Keep disabled on error
      }
    }

    auditButton.addEventListener('click', async () => {
      auditButton.disabled = true // Disable immediately

      // Re-fetch params in case of SPA navigation changes, though less likely for injects
      const {
        property_hr_id: current_property_hr_id,
        startDate: current_startDate,
        endDate: current_endDate,
      } = getUrlParams()

      if (!current_property_hr_id || !current_startDate || !current_endDate) {
        console.error(
          'Lux Inject: Critical - property_hr_id, startDate, or endDate missing on click. This should not happen if button was enabled.'
        )
        currentShowToast(
          'Fehler: Audit-Parameter fehlen. Bitte Seite neu laden.',
          'error'
        )
        // Keep button disabled as state is inconsistent
        return
      }

      const userName = localStorage.getItem('userName') || 'advisory council'
      const authString = localStorage.getItem('auth');
      const authData = JSON.parse(authString);
      const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
      const domainId = decodedToken.domainId
      const url = window.location.host

      const auditData = {
        property_hr_id: current_property_hr_id,
        startDate: current_startDate,
        endDate: current_endDate,
        audit_completed_at: new Date().toISOString(),
        audit_completed_by: userName,
        domainId,
        url
      }

      try {
        const response = await currentApiClientPost(
          '/api/properties',
          auditData
        )
        if (response.ok) {
          auditButton.textContent = 'Belegprüfung abgeschlossen'
          // Button remains disabled
          currentShowToast('Belegprüfung erfolgreich abgeschlossen.', 'success')
          console.log('Lux Inject: Audit successfully recorded.')
        } else {
          const errorText = await response.text()
          console.error('API Error:', response.status, errorText)
          currentShowToast(
            'Fehler beim Abschliessen der Belegprüfung.',
            'error'
          )
          auditButton.disabled = false // Re-enable on API error
          auditButton.textContent = 'Belegprüfung abschliessen' // Revert text
        }
      } catch (error) {
        console.error('Lux Inject: Failed to send audit data', error)
        currentShowToast(
          'Netzwerkfehler oder Authentifizierungsproblem.',
          'error'
        )
        auditButton.disabled = false // Re-enable on catch
        auditButton.textContent = 'Belegprüfung abschliessen' // Revert text
      }
    })

    // Button is already inserted, just confirm setup logic is complete for the interval
    console.log('Lux Inject: Audit button async setup complete.')
    return true
  }

  const checkInterval = setInterval(async () => {
    const anchor = document.querySelector(anchorSelector)
    if (anchor) {
      // Check if button already exists before attempting to initialize
      // This is a secondary check; primary check is inside initializeButton
      if (document.getElementById(buttonId)) {
        console.log(
          'Lux Inject: Interval found button already exists, clearing interval.'
        )
        clearInterval(checkInterval)
        return
      }
      if (await initializeButton()) {
        clearInterval(checkInterval)
      }
    }
  }, 500)
}
